import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_TRAVEL_DELAY_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    travelDelay: 'false',
    enableTime: null,
    schoolNameForDelay: '',
    companyNameTravelDelay: '',
    addressTravelDelay: '',
    cityTravelDelay: '',
    stateTravelDelay: '',
    zipCodeTravelDelay: '',
    contactTravelDelay: '',
    phoneNumberTravelDelay: '',
    dateOfInitialPaymentDeposit: '',
    includedInPackageForDelay: '',
    dateYouWereDueToDepart: '',
    timeYouWereDueToDepart: null,
    dateTripWasDelayed: '',
    dateDelayEnded: '',
    dateYouActuallyDeparted: '',
    timeYouActuallyDeparted: null,
    delayInformationItems: [],
    dateTripWasDelayedWithTravelSupplier: '',
    dateDelayEndedForDelay: '',
    detailsRegardingYourTripDelay: '',
    insuredsTripDelay: [],

    // New Question 1
    areYouClaimingForTripDelayPerDay: 'false',

    // New Question 2
    areYouClaimingForKennelFeesAtHome: 'false',

    // New Question 3
    areYouClaimingForKennelFeesOnTrip: 'false',
  },
  errors: [],
});

const initialTravelDelayState = {
  form: {
    travelDelay: 'false',
    schoolNameForDelay: '',
    reasonsForDelay: [],
    companyNameTravelDelay: '',
    addressTravelDelay: '',
    cityTravelDelay: '',
    stateTravelDelay: '',
    zipCodeTravelDelay: '',
    contactTravelDelay: '',
    phoneNumberTravelDelay: '',
    dateOfInitialPaymentDeposit: '',
    includedInPackageForDelay: '',
    dateYouWereDueToDepart: '',
    timeYouWereDueToDepart: null,
    dateTripWasDelayed: '',
    dateDelayEnded: '',
    dateYouActuallyDeparted: '',
    timeYouActuallyDeparted: null,
    delayInformationItems: [],
  },
};

function tripDelayStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_TRAVEL_DELAY_STATE:
      return state
          .setIn(['form', 'delayInformationItems'], [])
          .mergeDeep(initialTravelDelayState);
    default:
      return state;
  }
}

export default tripDelayStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.TripDelayStep/reducer.js